import { useAuth } from '@/auth/AuthProvider';
import { useTeamData } from '@/hooks/users/useTeamData';
import { TeamMember } from '@/types/auth/auth';

/**
 * Team members eligible to default-fill an activation "send to" list —
 * excludes the caller and anyone without an email on file.
 */
export const useTeamRecipients = (): { members: TeamMember[]; isLoading: boolean } => {
  const { user, team } = useAuth();
  const { data: teamData, isLoading } = useTeamData(team?.id, user?.id);

  const members = (teamData?.members || []).filter(
    (member): member is TeamMember & { email: string } => !!member.email && member.id !== user?.id,
  );

  return { members, isLoading: isLoading && !!team?.id };
};
